module.exports = __webpack_public_path__ + "src/assets/games/18/13.jpg";